<div class="entity-edit-page max-w-[600px]">
  <header class="mb-6">
    <h1 class="m-0 mb-3 text-3xl font-extrabold tracking-tight text-fg">Edit {{ entityConfig.label }} #{{ id }}</h1>
    <button type="button" class="back inline-flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 text-[0.9375rem] font-semibold text-fg-secondary transition-colors hover:text-fg" (click)="goBack()">← Back</button>
  </header>
  @if (initialValue(); as initial) {
    <lib-dynamic-form
      [resourcePath]="resourcePath"
      [initialValue]="initial"
      (formSubmit)="onSubmit($event)"
      (cancel)="onCancel()"
    />
  } @else {
    <p class="text-sm text-muted">Loading form…</p>
  }
</div>
